import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from '@/store';
import useJSXRoutes from '@/routes';
import { ThemeProvider } from 'hooks/useThemeQuery';
import { Toaster } from '@zawarski/eti-ui';

function AppContent() {
  const router = useJSXRoutes();

  return (
    <div>
      <Provider store={store}>
        <Toaster richColors position={'top-right'} />
        <RouterProvider router={router} />
      </Provider>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
